import { call, put, takeLatest } from 'redux-saga/effects';
import { WORKFLOWS_ACTION_TYPES } from './workflows.types';
import {
  getWorkflowByCampaignId,
  publishWorkflow,
  updateWorkflow,
} from '../../services/workflowService/workflowService';
import {
  fetchWorkflowsSuccess,
  fetchWorkflowsFailure,
  getWorkflowByCampaignSuccess,
  getWorkflowByCampaignFailure,
  updateWorkflowSuccess,
  updateWorkflowFailure,
  publishWorkflowSuccess,
  publishWorkflowFailure,
} from './workflows.action';
import { reviewCampaignRequest } from 'store/campaigns';

function* fetchWorkflowsSaga(): Generator<any, void, any> {
  try {
    // This would be implemented when we have a list endpoint
    const workflows: any[] = yield call(getWorkflowByCampaignId, '');
    yield put(fetchWorkflowsSuccess(workflows));
  } catch (error: any) {
    yield put(fetchWorkflowsFailure(error.message));
  }
}

function* getWorkflowByCampaignSaga(action: any): Generator<any, void, any> {
  try {
    const workflow = yield call(getWorkflowByCampaignId, action.payload);
    yield put(getWorkflowByCampaignSuccess(workflow));
  } catch (error: any) {
    yield put(getWorkflowByCampaignFailure(error.message));
  }
}

function* updateWorkflowSaga(action: any): Generator<any, void, any> {
  try {
    const workflow = yield call(updateWorkflow, action.payload);
    yield put(updateWorkflowSuccess(workflow));
    yield put(reviewCampaignRequest(action.payload.campaignId));
  } catch (error: any) {
    yield put(updateWorkflowFailure(error.message));
  }
}

function* publishWorkflowSaga(action: any): Generator<any, void, any> {
  try {
    const workflow = yield call(publishWorkflow, action.payload);
    yield put(publishWorkflowSuccess(workflow));
  } catch (error: any) {
    yield put(publishWorkflowFailure(error.message));
  }
}

export function* workflowsSaga(): Generator<any, void, any> {
  yield takeLatest(
    WORKFLOWS_ACTION_TYPES.FETCH_WORKFLOWS_REQUEST,
    fetchWorkflowsSaga
  );
  yield takeLatest(
    WORKFLOWS_ACTION_TYPES.GET_WORKFLOW_BY_CAMPAIGN_REQUEST,
    getWorkflowByCampaignSaga
  );
  yield takeLatest(
    WORKFLOWS_ACTION_TYPES.UPDATE_WORKFLOW_REQUEST,
    updateWorkflowSaga
  );
  yield takeLatest(
    WORKFLOWS_ACTION_TYPES.PUBLISH_WORKFLOW_REQUEST,
    publishWorkflowSaga
  );
}
